import React, { memo } from 'react';
import PropTypes from 'prop-types';
import WrapperContainer from '../../../components/MUI/SummaryWrapper/WrapperContainer';
import useDeviceResize from '../../../hooks/useDeviceResize';

import useStyles from './makeStyles';

const PolicySummaryWrapper = ({ children, openMobileSummary, onDismiss }) => {
  const isDeviceLgSize = useDeviceResize('extraLgSize');
  const classes = useStyles({ isDeviceLgSize });

  return (
    <WrapperContainer
      classes={classes}
      isDeviceLgSize={isDeviceLgSize}
      onDismiss={onDismiss}
      openMobileSummary={openMobileSummary}
    >
      {children}
    </WrapperContainer>
  );
};

PolicySummaryWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  openMobileSummary: PropTypes.bool,
  onDismiss: PropTypes.func.isRequired,
};

PolicySummaryWrapper.defaultProps = {
  openMobileSummary: false,
};

export default memo(PolicySummaryWrapper);
